window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('alpinejs');

import swal from 'sweetalert';
import { createApp } from 'vue'
import LeadWrapper from './lead/lead-wrapper.vue';
import DocPassword from './DocPassword.vue';
import emitter from 'tiny-emitter/instance'
const app = createApp({
	components: {
		LeadWrapper,
		DocPassword
	},
	methods: {
		toggleForm(gallery = null) {
			emitter.emit('leadForm', gallery);
		},
		showDocPassord(gallery) {
			emitter.emit('passwordForm', gallery);
		}
	},
}).mount('#app');
if (app) {
	window.appMethods = {
		toggleForm: app.toggleForm.bind(app),
		showDocPassord: app.showDocPassord.bind(app)
	}
}
window.hasSubmitted = false;